import { get, isArray, isPlainObject, isString, transform } from 'lodash';

export const transformTheme = (element, theme) => {
    return transform(element, (result, value, key) => {
        if (isPlainObject(value)) {
            result[key] = transformTheme(value, theme);
        } else if (isArray(value)) {
            result[key] = value.map(item => {
                if (isPlainObject(item)) {
                    return transformTheme(item, theme);
                }
                return item;
            });
        } else if (
            key !== 'text' &&
            isString(value) &&
            value.startsWith('$theme.')
        ) {
            result[key] = get(theme, value.replace('$theme.', ''));
            if (result[key] === undefined) {
                console.warn(`Theme variable '${value}' is not defined`);
            }
        } else {
            result[key] = value;
        }
    });
};
